import { createRoot } from 'react-dom/client'; // For React 18+

import "./view.scss";

const initView = () => {
    // Find all instances of your block's mount point on the page
    const mountPoints = document.querySelectorAll('.wp-block-prismal-view:not(.wp-block-prismal-hydrated)');

    mountPoints.forEach(mountPoint => {
        // Retrieve props from data-props (saved in save.js)
        const propsString = mountPoint.dataset.props;
        let props = {};
        try {
            props = JSON.parse(propsString);
        } catch (e) {
            console.error('Failed to parse block props from data-props:', e);
            return;
        }

        // Hydrate the React component into the mount point
        const root = createRoot(mountPoint);
        root.render(window.prismal.parserMap(mountPoint.outerHTML));
    });
}

if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initView);
} else {
    initView();
}
